import { render, staticRenderFns } from "./SelfCase.vue?vue&type=template&id=dcbae0ce&scoped=true&"
import script from "./SelfCase.vue?vue&type=script&lang=js&"
export * from "./SelfCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbae0ce",
  null
  
)

component.options.__file = "SelfCase.vue"
export default component.exports